import { render, staticRenderFns } from "./NotificationTemplateForm.vue?vue&type=template&id=2983bb03&"
import script from "./NotificationTemplateForm.vue?vue&type=script&lang=js&"
export * from "./NotificationTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports